import React, { useState, useEffect } from 'react'
import TopBar from '../../Components/OrganisationAdmin/TopBar'
import SideBar from '../../Components/OrganisationAdmin/SideBar'
import Main from '../../Components/OrganisationAdmin/Main'
import { getUserInfoSync } from '../../config/api'

const OrganisationAdminDashboard = () => {
  const [sidebarToggle, setSidebarToggle] = useState(false)
  const userInfo = getUserInfoSync()
  const isFirstLogin = userInfo?.first_login === true
  const [activeScreen, setActiveScreen] = useState(isFirstLogin ? 'profile' : 'dashboard')
  const [screenParams, setScreenParams] = useState(null)

  const handleSidebarToggle = () => {
    setSidebarToggle(!sidebarToggle)
  }

  useEffect(() => {
    // Toggle the class on body element based on sidebarToggle state
    if (sidebarToggle) {
      document.body.classList.add('toggle-sidebar')
    } else {
      document.body.classList.remove('toggle-sidebar')
    }
  }, [sidebarToggle])

  // Force profile screen if first login
  useEffect(() => {
    if (isFirstLogin && activeScreen !== 'profile') {
      setActiveScreen('profile')
    }
  }, [isFirstLogin, activeScreen])

  // Initialize Bootstrap collapse functionality
  useEffect(() => {
    // Ensure Bootstrap collapse is initialized
    const initBootstrap = () => {
      if (window.bootstrap && window.bootstrap.Collapse) {
        document.querySelectorAll('[data-bs-toggle="collapse"]').forEach(element => {
          new window.bootstrap.Collapse(element, { toggle: false })
        })
      }
    }
    
    // Wait for Bootstrap to load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBootstrap)
    } else {
      initBootstrap()
    }
  }, [activeScreen])

  // Handle navigation events from child components
  useEffect(() => {
    const handleNavigate = (event) => {
      const { screen, params } = event.detail
      if (screen && (!isFirstLogin || screen === 'profile')) {
        setActiveScreen(screen)
        setScreenParams(params || null)
      }
    }

    window.addEventListener('navigateToScreen', handleNavigate)
    return () => {
      window.removeEventListener('navigateToScreen', handleNavigate)
    }
  }, [isFirstLogin])

  useEffect(() => {
    const screensRequiringParams = ['stock-movement-detail', 'branch-stock']
    if (!screensRequiringParams.includes(activeScreen)) {
      setScreenParams(null)
    }
  }, [activeScreen])

  return (
    <>
    <TopBar onToggleSidebar={handleSidebarToggle} setActiveScreen={setActiveScreen}/>
    <SideBar activeScreen={activeScreen} setActiveScreen={setActiveScreen} isFirstLogin={isFirstLogin}/>
    <Main activeScreen={activeScreen} isFirstLogin={isFirstLogin} screenParams={screenParams}/>

    </>
  )
}

export default OrganisationAdminDashboard